import { ConfirmModal } from '@cian/frontend-e2e-deal-component';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useBuildShortFormUrl } from '../../hooks/useBuildShortFormUrl';
import { closeUnfinishedAnketaModal } from '../../redux';
import {
  selectFormDefaults,
  selectIsUnfinishedAnketaModalOpen,
  selectUnfinishedAnketaModalNewAnketaUrl,
  selectUnfinishedAnketaModalOffer,
} from '../../selectors/calculator';
import { redirect } from '../../utils';
import { getUserInput } from '../../utils/tracking/getUserInput';
import { useTracking } from '../../utils/tracking/useTracking';

import {
  UNFINISHED_ANKETA_MODAL_CONTINUE_BUTTON,
  UNFINISHED_ANKETA_MODAL_DESCRIPTION,
  UNFINISHED_ANKETA_MODAL_START_NEW_BUTTON,
  UNFINISHED_ANKETA_MODAL_TITLE,
} from './constants';

export const UnfinishedAnketaModalContainer: React.FC = () => {
  const dispatch = useDispatch();
  const buildShortFormUrl = useBuildShortFormUrl();
  const isOpen = useSelector(selectIsUnfinishedAnketaModalOpen);
  const offer = useSelector(selectUnfinishedAnketaModalOffer);
  const formState = useSelector(selectFormDefaults);
  const newAnketaUrl = useSelector(selectUnfinishedAnketaModalNewAnketaUrl);
  const { trackShowUnfinishedAnketaModal, trackClickStartNewAnketa, trackClickContinueOldAnketa } = useTracking();

  const userInput = getUserInput(formState);

  useEffect(() => {
    if (isOpen) {
      trackShowUnfinishedAnketaModal({ offer, userInput });
    }
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const handleClose = () => {
    dispatch(closeUnfinishedAnketaModal());
  };

  /* Ссылку собрал флоу, открывший модалку: здесь неизвестны ни заявка, ни банк оффера */
  const handleStartNew = () => {
    trackClickStartNewAnketa({ offer, userInput });
    dispatch(closeUnfinishedAnketaModal());

    if (newAnketaUrl) {
      redirect(newAnketaUrl);
    }
  };

  /* Шаг черновика не передаём: его получит сама анкета через get-draft-state.
     Параметры расчёта тоже не нужны — у существующего черновика уже есть свои */
  const handleContinueOld = () => {
    trackClickContinueOldAnketa({ offer, userInput });
    dispatch(closeUnfinishedAnketaModal());
    redirect(buildShortFormUrl({ draftAction: 'continue' }));
  };

  return (
    <ConfirmModal
      open={isOpen}
      onClose={handleClose}
      title={UNFINISHED_ANKETA_MODAL_TITLE}
      primaryButtonText={UNFINISHED_ANKETA_MODAL_START_NEW_BUTTON}
      onPrimaryClick={handleStartNew}
      secondaryButtonText={UNFINISHED_ANKETA_MODAL_CONTINUE_BUTTON}
      onSecondaryClick={handleContinueOld}
    >
      {UNFINISHED_ANKETA_MODAL_DESCRIPTION}
    </ConfirmModal>
  );
};

UnfinishedAnketaModalContainer.displayName = 'UnfinishedAnketaModalContainer';
